import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "작업 실행",
  "description": "turbo CLI를 통해 저장소에서 작업을 실행하는 방법을 알아봅니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo는 자동으로 작업을 병렬화하고 캐시하여 저장소의 개발자 워크플로를 최적화합니다. 작업이 turbo.json에 등록되면 저장소에서 스크립트를 실행하기 위한 강력한 새 도구 세트를 사용할 수 있습니다:"
  }, {
    "heading": "",
    "content": "자주 실행해야 하는 작업에 package.json의 scripts 사용"
  }, {
    "heading": "",
    "content": "전역 turbo를 사용하여 주문형 사용자 정의 작업을 빠르게 실행"
  }, {
    "heading": "",
    "content": "디렉토리, 패키지 이름, 소스 제어 변경 사항 등으로 작업 필터링"
  }, {
    "heading": "",
    "content": "turbo를 통해 작업을 실행하는 것은 개발 및 CI 파이프라인에서 저장소 전체에 걸쳐 워크플로를 실행하기 위한 하나의 모델을 얻기 때문에 강력합니다."
  }, {
    "heading": "packagejson에서-scripts-사용",
    "content": "자주 실행하는 작업의 경우 루트 package.json에 turbo 명령을 직접 작성할 수 있습니다."
  }, {
    "heading": "packagejson에서-scripts-사용",
    "content": "turbo는 turbo run의 별칭입니다. 하지만 향후 추가될 수 있는 turbo 하위\n명령과의 충돌을 피하기 위해 package.json 및 CI 워크플로에서는 turbo run을\n사용하는 것이 좋습니다."
  }, {
    "heading": "packagejson에서-scripts-사용",
    "content": "그런 다음 패키지 관리자를 사용하여 이러한 스크립트를 실행할 수 있습니다."
  }, {
    "heading": "packagejson에서-scripts-사용",
    "content": "루트 package.json에만 turbo 명령을 작성하세요. 패키지의 package.json에 turbo 명령을 작성하면 turbo를 재귀적으로 호출할 수 있습니다."
  }, {
    "heading": "전역-turbo-사용",
    "content": "turbo를 전역으로 설치하면 터미널에서 직접 명령을 실행할 수 있습니다. 이는 필요한 것을 정확히 실행하기가 더 쉬워지므로 로컬 개발 경험을 향상시킵니다."
  }, {
    "heading": "전역-turbo-사용",
    "content": "또한 전역 turbo는 CI 파이프라인에서 유용하며 파이프라인의 각 지점에서 실행할 작업을 최대한 제어할 수 있습니다."
  }, {
    "heading": "automatic-package-scoping",
    "content": "패키지의 디렉토리에 있을 때 turbo는 자동으로 해당 패키지의 Package Graph로 명령을 스코핑합니다. 즉, 패키지에 대한 필터를 작성하지 않고도 빠르게 명령을 작성할 수 있습니다."
  }, {
    "heading": "automatic-package-scoping",
    "content": "위의 예에서 turbo build 명령은 turbo.json에 등록된 build 작업을 사용하여 docs 패키지에 대한 build 작업을 실행합니다."
  }, {
    "heading": "automatic-package-scoping",
    "content": "필터 사용은 Automatic Package Scoping을 재정의합니다."
  }, {
    "heading": "동작-사용자-지정",
    "content": "run 하위 명령 문서에서 필요한 것에 맞게 turbo run의 동작을 조정하는 데 유용한 많은 플래그를 찾을 수 있습니다. 전역 turbo를 실행할 때 다음과 같은 워크플로를 사용하여 더 빠르게 진행할 수 있습니다:"
  }, {
    "heading": "동작-사용자-지정",
    "content": "가장 일반적인 명령의 변형: package.json의 build 스크립트는 turbo build일 때 가장 유용하지만 현재 특정 패키지에만 관심이 있을 수 있습니다. turbo build --filter=@repo/ui를 사용하여 관심 있는 특정 패키지를 빠르게 필터링할 수 있습니다."
  }, {
    "heading": "동작-사용자-지정",
    "content": "일회성 명령: turbo build --dry와 같은 명령은 자주 필요하지 않으므로 package.json에 스크립트를 만들지 않을 것입니다. 대신 필요할 때마다 터미널에서 직접 실행할 수 있습니다."
  }, {
    "heading": "동작-사용자-지정",
    "content": "turbo.json 구성 재정의: 일부 CLI 플래그에는 재정의할 수 있는 turbo.json의 동등한 플래그가 있습니다. 예를 들어 turbo.json에서 \"outputLogs\": \"full\"을 사용하도록 구성된 turbo build 명령이 있지만 현재 오류만 보고 싶을 수 있습니다. 전역 turbo를 사용하여 turbo lint --output-logs=errors-only를 사용하여 오류만 표시할 수 있습니다."
  }, {
    "heading": "여러-작업-실행",
    "content": "turbo는 여러 작업을 실행할 수 있으며 가능한 한 병렬화합니다."
  }, {
    "heading": "여러-작업-실행",
    "content": "이 명령은 모든 작업을 실행하며 작업 정의에 따라 스크립트를 가능한 한 빨리 실행할 수 있는 위치를 자동으로 감지합니다."
  }, {
    "heading": "여러-작업-실행",
    "content": "turbo test lint는 turbo lint test와 정확히 동일한 작업을 실행합니다."
  }, {
    "heading": "여러-작업-실행",
    "content": "한 작업이 다른 작업의 실행을 차단하도록 하려면 작업 구성에서 해당 관계를 표현하세요."
  }, {
    "heading": "필터-사용",
    "content": "캐싱은 동일한 작업을 두 번 수행하지 않도록 하여 빠르게 유지하지만 the Task Graph의 하위 집합만 실행하도록 작업을 필터링할 수도 있습니다."
  }, {
    "heading": "필터-사용",
    "content": "--filter API 참조에는 필터링에 대한 많은 고급 사용 사례가 있지만 가장 일반적인 사용 사례는 아래에서 설명합니다."
  }, {
    "heading": "패키지별-필터링",
    "content": "패키지별 필터링은 현재 작업 중인 패키지에 대해서만 작업을 실행하는 간단한 방법입니다."
  }, {
    "heading": "패키지별-필터링",
    "content": "--filter를 사용하지 않고도 CLI 명령에서 패키지에 대한 특정 작업으로 직접 필터링할 수도 있습니다:"
  }, {
    "heading": "디렉토리별-필터링",
    "content": "저장소에는 관련 패키지가 함께 그룹화된 디렉토리 구조가 있을 수 있습니다. 이 경우 해당 디렉토리에 대한 glob을 캡처하여 turbo를 해당 패키지에 집중할 수 있습니다."
  }, {
    "heading": "종속자를-포함하도록-필터링",
    "content": "특정 패키지에서 작업할 때 패키지와 해당 종속자에 대한 작업을 실행할 수 있습니다. ... 마이크로 구문은 패키지를 변경하고 해당 변경 사항이 종속자를 손상시키지 않도록 할 때 유용합니다."
  }, {
    "heading": "종속성을-포함하도록-필터링",
    "content": "범위를 패키지 및 해당 종속성으로 제한하려면 패키지 이름에 ...를 추가합니다. 이는 지정된 패키지와 해당 패키지가 의존하는 모든 패키지에 대해 작업을 실행합니다."
  }, {
    "heading": "소스-제어-변경-사항별-필터링",
    "content": "필터를 사용하여 소스 제어의 변경 사항을 기반으로 작업을 실행하는 것은 변경 사항의 영향을 받는 패키지에 대해서만 작업을 실행하는 좋은 방법입니다. 소스 제어 필터는 []로 래핑해야 합니다."
  }, {
    "heading": "소스-제어-변경-사항별-필터링",
    "content": "이전 커밋과 비교: turbo build --filter=[HEAD^1]"
  }, {
    "heading": "소스-제어-변경-사항별-필터링",
    "content": "메인 브랜치와 비교: turbo build --filter=[main...my-feature]"
  }, {
    "heading": "소스-제어-변경-사항별-필터링",
    "content": "SHA를 사용하여 특정 커밋 비교: turbo build --filter=[a1b2c3d...e4f5g6h]"
  }, {
    "heading": "소스-제어-변경-사항별-필터링",
    "content": "브랜치 이름을 사용하여 특정 커밋 비교: turbo build --filter=[your-feature...my-feature]"
  }, {
    "heading": "소스-제어-변경-사항별-필터링",
    "content": "일반적으로 캐싱에 의존하여 저장소를 빠르게 유지할 수 있습니다. Remote\nCaching을 사용하는 경우 변경되지 않은\n패키지에 대해 캐시를 히트할 수 있습니다."
  }, {
    "heading": "필터-결합",
    "content": "더욱 구체적으로 하려면 필터를 결합하여 Task Graph의 진입점을 더욱 세분화할 수 있습니다."
  }, {
    "heading": "필터-결합",
    "content": "여러 필터는 합집합으로 결합됩니다. 즉, Task Graph에는 필터 중 하나와 일치하는 작업이 포함됩니다. 필터의 고급 사용에 대한 자세한 내용은 --filter API 참조를 참조하세요."
  }, {
    "heading": "다음-단계",
    "content": "저장소에서 작업을 실행하기 시작하면 작업이 더 빠르게 실행되는 것을 알 수 있습니다. 다음으로 캐싱과 turbo가 동일한 작업을 두 번 수행하지 않도록 하는 방법을 탐색합니다."
  }],
  "headings": [{
    "id": "packagejson에서-scripts-사용",
    "content": "package.json에서 scripts 사용"
  }, {
    "id": "전역-turbo-사용",
    "content": "전역 turbo 사용"
  }, {
    "id": "automatic-package-scoping",
    "content": "Automatic Package Scoping"
  }, {
    "id": "동작-사용자-지정",
    "content": "동작 사용자 지정"
  }, {
    "id": "여러-작업-실행",
    "content": "여러 작업 실행"
  }, {
    "id": "필터-사용",
    "content": "필터 사용"
  }, {
    "id": "패키지별-필터링",
    "content": "패키지별 필터링"
  }, {
    "id": "디렉토리별-필터링",
    "content": "디렉토리별 필터링"
  }, {
    "id": "종속자를-포함하도록-필터링",
    "content": "종속자를 포함하도록 필터링"
  }, {
    "id": "종속성을-포함하도록-필터링",
    "content": "종속성을 포함하도록 필터링"
  }, {
    "id": "소스-제어-변경-사항별-필터링",
    "content": "소스 제어 변경 사항별 필터링"
  }, {
    "id": "필터-결합",
    "content": "필터 결합"
  }, {
    "id": "다음-단계",
    "content": "다음 단계"
  }]
};
import {Callout} from '#components/callout';
import {PackageManagerTabs, Tab} from '#components/tabs';
import {LinkToDocumentation} from '#components/link-to-documentation';
import {InVersion} from '#components/in-version';
export const toc = [{
  depth: 2,
  url: "#packagejson에서-scripts-사용",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "package.json"
    }), "에서 ", _jsx("code", {
      children: "scripts"
    }), " 사용"]
  })
}, {
  depth: 2,
  url: "#전역-turbo-사용",
  title: _jsxs(_Fragment, {
    children: ["전역 ", _jsx("code", {
      children: "turbo"
    }), " 사용"]
  })
}, {
  depth: 3,
  url: "#automatic-package-scoping",
  title: _jsx(_Fragment, {
    children: "Automatic Package Scoping"
  })
}, {
  depth: 3,
  url: "#동작-사용자-지정",
  title: _jsx(_Fragment, {
    children: "동작 사용자 지정"
  })
}, {
  depth: 2,
  url: "#여러-작업-실행",
  title: _jsx(_Fragment, {
    children: "여러 작업 실행"
  })
}, {
  depth: 2,
  url: "#필터-사용",
  title: _jsx(_Fragment, {
    children: "필터 사용"
  })
}, {
  depth: 3,
  url: "#패키지별-필터링",
  title: _jsx(_Fragment, {
    children: "패키지별 필터링"
  })
}, {
  depth: 3,
  url: "#디렉토리별-필터링",
  title: _jsx(_Fragment, {
    children: "디렉토리별 필터링"
  })
}, {
  depth: 3,
  url: "#종속자를-포함하도록-필터링",
  title: _jsx(_Fragment, {
    children: "종속자를 포함하도록 필터링"
  })
}, {
  depth: 3,
  url: "#종속성을-포함하도록-필터링",
  title: _jsx(_Fragment, {
    children: "종속성을 포함하도록 필터링"
  })
}, {
  depth: 3,
  url: "#소스-제어-변경-사항별-필터링",
  title: _jsx(_Fragment, {
    children: "소스 제어 변경 사항별 필터링"
  })
}, {
  depth: 3,
  url: "#필터-결합",
  title: _jsx(_Fragment, {
    children: "필터 결합"
  })
}, {
  depth: 2,
  url: "#다음-단계",
  title: _jsx(_Fragment, {
    children: "다음 단계"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Turborepo는 자동으로 작업을 병렬화하고 캐시하여 저장소의 개발자 워크플로를 최적화합니다. 작업이 ", _jsxs(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks",
        children: [_jsx(_components.code, {
          children: "turbo.json"
        }), "에 등록"]
      }), "되면 저장소에서 스크립트를 실행하기 위한 강력한 새 도구 세트를 사용할 수 있습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsxs(_components.a, {
          href: "#using-scripts-in-packagejson",
          children: ["자주 실행해야 하는 작업에 ", _jsx(_components.code, {
            children: "package.json"
          }), "의 ", _jsx(_components.code, {
            children: "scripts"
          }), " 사용"]
        })
      }), "\n", _jsx(_components.li, {
        children: _jsxs(_components.a, {
          href: "#using-global-turbo",
          children: ["전역 ", _jsx(_components.code, {
            children: "turbo"
          }), "를 사용하여 주문형 사용자 정의 작업을 빠르게 실행"]
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "#using-filters",
          children: "디렉토리, 패키지 이름, 소스 제어 변경 사항 등으로 작업 필터링"
        })
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), "를 통해 작업을 실행하는 것은 개발 및 CI 파이프라인에서 저장소 전체에 걸쳐 워크플로를 실행하기 위한 하나의 모델을 얻기 때문에 강력합니다."]
    }), "\n", _jsxs(_components.h2, {
      id: "packagejson에서-scripts-사용",
      children: [_jsx(_components.code, {
        children: "package.json"
      }), "에서 ", _jsx(_components.code, {
        children: "scripts"
      }), " 사용"]
    }), "\n", _jsxs(_components.p, {
      children: ["자주 실행하는 작업의 경우 루트 ", _jsx(_components.code, {
        children: "package.json"
      }), "에 ", _jsx(_components.code, {
        children: "turbo"
      }), " 명령을 직접 작성할 수 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo run dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo run build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo run test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"lint\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"turbo run lint\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(Callout, {
      type: "good-to-know",
      children: _jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "turbo"
        }), "는 ", _jsx(_components.code, {
          children: "turbo run"
        }), "의 별칭입니다. 하지만 향후 추가될 수 있는 ", _jsx(_components.code, {
          children: "turbo"
        }), " 하위\n명령과의 충돌을 피하기 위해 ", _jsx(_components.code, {
          children: "package.json"
        }), " 및 CI 워크플로에서는 ", _jsx(_components.code, {
          children: "turbo run"
        }), "을\n사용하는 것이 좋습니다."]
      })
    }), "\n", _jsx(_components.p, {
      children: "그런 다음 패키지 관리자를 사용하여 이러한 스크립트를 실행할 수 있습니다."
    }), "\n", _jsxs(PackageManagerTabs, {
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "pnpm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dev"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "yarn"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dev"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "npm"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " run"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dev"
                })]
              })
            })
          })
        })
      }), _jsx(Tab, {
        value: "bun (Beta)",
        children: _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "Terminal",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
            children: _jsx(_components.code, {
              children: _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-function)",
                    "--shiki-dark": "var(--shiki-token-function)"
                  },
                  children: "bun"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " run"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string)",
                    "--shiki-dark": "var(--shiki-token-string)"
                  },
                  children: " dev"
                })]
              })
            })
          })
        })
      })]
    }), "\n", _jsx(Callout, {
      type: "warn",
      children: _jsxs(_components.p, {
        children: ["루트 ", _jsx(_components.code, {
          children: "package.json"
        }), "에만 ", _jsx(_components.code, {
          children: "turbo"
        }), " 명령을 작성하세요. 패키지의 ", _jsx(_components.code, {
          children: "package.json"
        }), "에 ", _jsx(_components.code, {
          children: "turbo"
        }), " 명령을 작성하면 ", _jsx(_components.code, {
          children: "turbo"
        }), "를 재귀적으로 호출할 수 있습니다."]
      })
    }), "\n", _jsxs(_components.h2, {
      id: "전역-turbo-사용",
      children: ["전역 ", _jsx(_components.code, {
        children: "turbo"
      }), " 사용"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "/docs/getting-started/installation#global-installation",
        children: [_jsx(_components.code, {
          children: "turbo"
        }), "를 전역으로 설치"]
      }), "하면 터미널에서 직접 명령을 실행할 수 있습니다. 이는 필요한 것을 정확히 실행하기가 더 쉬워지므로 로컬 개발 경험을 향상시킵니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["또한 전역 ", _jsx(_components.code, {
        children: "turbo"
      }), "는 CI 파이프라인에서 유용하며 파이프라인의 각 지점에서 실행할 작업을 최대한 제어할 수 있습니다."]
    }), "\n", _jsx(_components.h3, {
      id: "automatic-package-scoping",
      children: "Automatic Package Scoping"
    }), "\n", _jsxs(_components.p, {
      children: ["패키지의 디렉토리에 있을 때 ", _jsx(_components.code, {
        children: "turbo"
      }), "는 자동으로 해당 패키지의 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#package-graph",
        children: "Package Graph"
      }), "로 명령을 스코핑합니다. 즉, 패키지에 대한 ", _jsx(_components.a, {
        href: "/docs/reference/run#--filter-string",
        children: "필터를 작성"
      }), "하지 않고도 빠르게 명령을 작성할 수 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "cd"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " apps/docs"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            })]
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["위의 예에서 ", _jsx(_components.code, {
        children: "turbo build"
      }), " 명령은 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "에 등록된 ", _jsx(_components.code, {
        children: "build"
      }), " 작업을 사용하여 ", _jsx(_components.code, {
        children: "docs"
      }), " 패키지에 대한 ", _jsx(_components.code, {
        children: "build"
      }), " 작업을 실행합니다."]
    }), "\n", _jsx(Callout, {
      type: "good-to-know",
      children: _jsxs(_components.p, {
        children: [_jsx(_components.a, {
          href: "#using-filters",
          children: "필터 사용"
        }), "은 Automatic Package Scoping을 재정의합니다."]
      })
    }), "\n", _jsx(_components.h3, {
      id: "동작-사용자-지정",
      children: "동작 사용자 지정"
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "/docs/reference/run",
        children: [_jsx(_components.code, {
          children: "run"
        }), " 하위 명령 문서"]
      }), "에서 필요한 것에 맞게 ", _jsx(_components.code, {
        children: "turbo run"
      }), "의 동작을 조정하는 데 유용한 많은 플래그를 찾을 수 있습니다. 전역 ", _jsx(_components.code, {
        children: "turbo"
      }), "를 실행할 때 다음과 같은 워크플로를 사용하여 더 빠르게 진행할 수 있습니다:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "가장 일반적인 명령의 변형"
        }), ": ", _jsx(_components.code, {
          children: "package.json"
        }), "의 ", _jsx(_components.code, {
          children: "build"
        }), " 스크립트는 ", _jsx(_components.code, {
          children: "turbo build"
        }), "일 때 가장 유용하지만 현재 특정 패키지에만 관심이 있을 수 있습니다. ", _jsx(_components.code, {
          children: "turbo build --filter=@repo/ui"
        }), "를 사용하여 관심 있는 특정 패키지를 빠르게 필터링할 수 있습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "일회성 명령"
        }), ": ", _jsx(_components.code, {
          children: "turbo build --dry"
        }), "와 같은 명령은 자주 필요하지 않으므로 ", _jsx(_components.code, {
          children: "package.json"
        }), "에 스크립트를 만들지 않을 것입니다. 대신 필요할 때마다 터미널에서 직접 실행할 수 있습니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsxs(_components.strong, {
          children: [_jsx(_components.code, {
            children: "turbo.json"
          }), " 구성 재정의"]
        }), ": 일부 CLI 플래그에는 재정의할 수 있는 ", _jsx(_components.code, {
          children: "turbo.json"
        }), "의 동등한 플래그가 있습니다. 예를 들어 ", _jsxs(_components.a, {
          href: "/docs/reference/configuration#outputlogs",
          children: [_jsx(_components.code, {
            children: "turbo.json"
          }), "에서 ", _jsx(_components.code, {
            children: "\"outputLogs\": \"full\""
          }), "을 사용"]
        }), "하도록 구성된 ", _jsx(_components.code, {
          children: "turbo build"
        }), " 명령이 있지만 현재 오류만 보고 싶을 수 있습니다. 전역 ", _jsx(_components.code, {
          children: "turbo"
        }), "를 사용하여 ", _jsx(_components.code, {
          children: "turbo lint --output-logs=errors-only"
        }), "를 사용하여 오류만 표시할 수 있습니다."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "여러-작업-실행",
      children: "여러 작업 실행"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), "는 여러 작업을 실행할 수 있으며 가능한 한 병렬화합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " test"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " lint"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " check-types"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "이 명령은 모든 작업을 실행하며 작업 정의에 따라 스크립트를 가능한 한 빨리 실행할 수 있는 위치를 자동으로 감지합니다."
    }), "\n", _jsxs(Callout, {
      type: "info",
      title: "작업 순서",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "turbo test lint"
        }), "는 ", _jsx(_components.code, {
          children: "turbo lint test"
        }), "와 정확히 동일한 작업을 실행합니다."]
      }), _jsxs(_components.p, {
        children: ["한 작업이 다른 작업의 실행을 차단하도록 하려면 ", _jsx(_components.a, {
          href: "/docs/crafting-your-repository/configuring-tasks#defining-tasks",
          children: "작업 구성"
        }), "에서 해당 관계를 표현하세요."]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "필터-사용",
      children: "필터 사용"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "/docs/crafting-your-repository/running-tasks",
        children: "캐싱"
      }), "은 동일한 작업을 두 번 수행하지 않도록 하여 빠르게 유지하지만 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#task-graph",
        children: "the Task Graph"
      }), "의 하위 집합만 실행하도록 작업을 필터링할 수도 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "/docs/reference/run#--filter-string",
        children: [_jsx(_components.code, {
          children: "--filter"
        }), " API 참조"]
      }), "에는 필터링에 대한 많은 고급 사용 사례가 있지만 가장 일반적인 사용 사례는 아래에서 설명합니다."]
    }), "\n", _jsx(_components.h3, {
      id: "패키지별-필터링",
      children: "패키지별 필터링"
    }), "\n", _jsx(_components.p, {
      children: "패키지별 필터링은 현재 작업 중인 패키지에 대해서만 작업을 실행하는 간단한 방법입니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=@acme/web"
            })]
          })
        })
      })
    }), "\n", _jsxs(InVersion, {
      version: "2.2.4",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: "--filter"
        }), "를 사용하지 않고도 CLI 명령에서 패키지에 대한 특정 작업으로 직접 필터링할 수도 있습니다:"]
      }), _jsx(_Fragment, {
        children: _jsx(_components.pre, {
          className: "shiki shiki-themes css-variables css-variables",
          style: {
            "--shiki-light": "var(--shiki-foreground)",
            "--shiki-dark": "var(--shiki-foreground)",
            "--shiki-light-bg": "var(--shiki-background)",
            "--shiki-dark-bg": "var(--shiki-background)"
          },
          tabIndex: "0",
          title: "Terminal",
          icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
          children: _jsxs(_components.code, {
            children: [_jsx(_components.span, {
              className: "line",
              children: _jsx(_components.span, {
                style: {
                  "--shiki-light": "var(--shiki-token-comment)",
                  "--shiki-dark": "var(--shiki-token-comment)"
                },
                children: "# `web` 패키지에 대한 `build` 작업 실행"
              })
            }), "\n", _jsxs(_components.span, {
              className: "line",
              children: [_jsx(_components.span, {
                style: {
                  "--shiki-light": "var(--shiki-token-function)",
                  "--shiki-dark": "var(--shiki-token-function)"
                },
                children: "turbo"
              }), _jsx(_components.span, {
                style: {
                  "--shiki-light": "var(--shiki-token-string)",
                  "--shiki-dark": "var(--shiki-token-string)"
                },
                children: " run"
              }), _jsx(_components.span, {
                style: {
                  "--shiki-light": "var(--shiki-token-string)",
                  "--shiki-dark": "var(--shiki-token-string)"
                },
                children: " web#build"
              })]
            }), "\n", _jsx(_components.span, {
              className: "line",
              children: " "
            }), "\n", _jsx(_components.span, {
              className: "line",
              children: _jsx(_components.span, {
                style: {
                  "--shiki-light": "var(--shiki-token-comment)",
                  "--shiki-dark": "var(--shiki-token-comment)"
                },
                children: "# `web` 패키지에 대한 `build` 작업과 `docs` 패키지에 대한 `lint` 작업 실행"
              })
            }), "\n", _jsxs(_components.span, {
              className: "line",
              children: [_jsx(_components.span, {
                style: {
                  "--shiki-light": "var(--shiki-token-function)",
                  "--shiki-dark": "var(--shiki-token-function)"
                },
                children: "turbo"
              }), _jsx(_components.span, {
                style: {
                  "--shiki-light": "var(--shiki-token-string)",
                  "--shiki-dark": "var(--shiki-token-string)"
                },
                children: " run"
              }), _jsx(_components.span, {
                style: {
                  "--shiki-light": "var(--shiki-token-string)",
                  "--shiki-dark": "var(--shiki-token-string)"
                },
                children: " web#build"
              }), _jsx(_components.span, {
                style: {
                  "--shiki-light": "var(--shiki-token-string)",
                  "--shiki-dark": "var(--shiki-token-string)"
                },
                children: " docs#lint"
              })]
            })]
          })
        })
      })]
    }), "\n", _jsx(_components.h3, {
      id: "디렉토리별-필터링",
      children: "디렉토리별 필터링"
    }), "\n", _jsxs(_components.p, {
      children: ["저장소에는 관련 패키지가 함께 그룹화된 디렉토리 구조가 있을 수 있습니다. 이 경우 해당 디렉토리에 대한 glob을 캡처하여 ", _jsx(_components.code, {
        children: "turbo"
      }), "를 해당 패키지에 집중할 수 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " lint"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"./packages/utilities/*\""
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "종속자를-포함하도록-필터링",
      children: "종속자를 포함하도록 필터링"
    }), "\n", _jsxs(_components.p, {
      children: ["특정 패키지에서 작업할 때 패키지와 해당 종속자에 대한 작업을 실행할 수 있습니다. ", _jsx(_components.code, {
        children: "..."
      }), " 마이크로 구문은 패키지를 변경하고 해당 변경 사항이 종속자를 손상시키지 않도록 할 때 유용합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=...ui"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "종속성을-포함하도록-필터링",
      children: "종속성을 포함하도록 필터링"
    }), "\n", _jsxs(_components.p, {
      children: ["범위를 패키지 및 해당 종속성으로 제한하려면 패키지 이름에 ", _jsx(_components.code, {
        children: "..."
      }), "를 추가합니다. 이는 지정된 패키지와 해당 패키지가 의존하는 모든 패키지에 대해 작업을 실행합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " dev"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=web..."
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "소스-제어-변경-사항별-필터링",
      children: "소스 제어 변경 사항별 필터링"
    }), "\n", _jsxs(_components.p, {
      children: ["필터를 사용하여 소스 제어의 변경 사항을 기반으로 작업을 실행하는 것은 변경 사항의 영향을 받는 패키지에 대해서만 작업을 실행하는 좋은 방법입니다. ", _jsxs(_components.strong, {
        children: ["소스 제어 필터는 ", _jsx(_components.code, {
          children: "[]"
        }), "로 래핑해야 합니다"]
      }), "."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "이전 커밋과 비교"
        }), ": ", _jsx(_components.code, {
          children: "turbo build --filter=[HEAD^1]"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "메인 브랜치와 비교"
        }), ": ", _jsx(_components.code, {
          children: "turbo build --filter=[main...my-feature]"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "SHA를 사용하여 특정 커밋 비교"
        }), ": ", _jsx(_components.code, {
          children: "turbo build --filter=[a1b2c3d...e4f5g6h]"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "브랜치 이름을 사용하여 특정 커밋 비교"
        }), ": ", _jsx(_components.code, {
          children: "turbo build --filter=[your-feature...my-feature]"
        })]
      }), "\n"]
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsxs(_components.p, {
        children: ["일반적으로 캐싱에 의존하여 저장소를 빠르게 유지할 수 있습니다. ", _jsx(_components.a, {
          href: "/docs/core-concepts/remote-caching",
          children: "Remote\nCaching"
        }), "을 사용하는 경우 변경되지 않은\n패키지에 대해 캐시를 히트할 수 있습니다."]
      })
    }), "\n", _jsx(_components.h3, {
      id: "필터-결합",
      children: "필터 결합"
    }), "\n", _jsxs(_components.p, {
      children: ["더욱 구체적으로 하려면 필터를 결합하여 ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#task-graph",
        children: "Task Graph"
      }), "의 진입점을 더욱 세분화할 수 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=...ui"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "./packages/*}"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --filter=[HEAD^1]"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["여러 필터는 ", _jsx(_components.strong, {
        children: "합집합"
      }), "으로 결합됩니다. 즉, ", _jsx(_components.a, {
        href: "/docs/core-concepts/package-and-task-graph#task-graph",
        children: "Task Graph"
      }), "에는 필터 중 하나와 일치하는 작업이 포함됩니다. 필터의 고급 사용에 대한 자세한 내용은 ", _jsxs(_components.a, {
        href: "/docs/reference/run#--filter-string",
        children: [_jsx(_components.code, {
          children: "--filter"
        }), " API 참조"]
      }), "를 참조하세요."]
    }), "\n", _jsx(_components.h2, {
      id: "다음-단계",
      children: "다음 단계"
    }), "\n", _jsxs(_components.p, {
      children: ["저장소에서 작업을 실행하기 시작하면 작업이 더 빠르게 실행되는 것을 알 수 있습니다. 다음으로 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/caching",
        children: "캐싱"
      }), "과 ", _jsx(_components.code, {
        children: "turbo"
      }), "가 동일한 작업을 두 번 수행하지 않도록 하는 방법을 탐색합니다."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
